module.exports = __webpack_public_path__ + "img/exhibitimgen.01bb31e0.png";